// extracted by css-extract-rspack-plugin
var _1 = "mGvCV";
var _2 = "U1nga";
var _3 = "g8swv";
export { _1 as "logo", _2 as "logoIcon", _3 as "logoIconMetaOS" }
